import clsx from "clsx";
import { TextProps } from "./PropsTypes";

export default function TextH1({ children, className }: TextProps) {
	return <h2 className={clsx("header-2 whitespace-pre-line", className)}>{children}</h2>;
}
